(function($) {

  'use strict';

  function IframeFluid() {

    var self = this,
        $el = null,
        options = {
          'example': null
        };

    function addCssStyles() {
      var ratio = 9 / 16 * 100;

      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = '.js-iframe-wrap {' +
        'padding-top: ' + ratio + '%;' +
        'position: relative;' +
        'width: 100%;' +
      '}' +

      '.js-iframe-wrap iframe {' +
        'height: 100%;' +
        'left: 0;' +
        'position: absolute;' +
        'top: 0;' +
        'width: 100%;' +
      '}';

      document.getElementsByTagName('head')[0].appendChild(style);
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $el = options.$el;

      // Wrap iframe inside div to make them fluid (in CSS) 
      var $iframe = $('iframe');
      if ($iframe.length > 0) {
        $iframe.each(function(index, el) {
          $(this).wrap('<div class="js-iframe-wrap"></div>');
        });

        // Add CSS styles
        addCssStyles();
      }

      //*************
      // window.cache.$window.on('resize', Utils.debounce(onResize, 400));
      // onResize();     // initial call on load
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.IframeFluid = IframeFluid;

}(jQuery));